<h2 mat-dialog-title class="dialog-title">Support</h2>
<div mat-dialog-content class="dialog-content">
  <p class="dialog-text">If you need help, please contact the Translate support team.</p>
  <p class="dialog-text">For urgent requests, use the internal IT support channel.</p>
</div>
<div mat-dialog-actions class="dialog-actions">
  <button mat-button mat-dialog-close>Close</button>
</div>
